export default __webpack_public_path__ + "static/media/gm-evo-girl.5e923761.webp";